<template>
  <div class="prefix-code-picker" @click="$emit('select')">
    <div class="code-text">{{ code }}</div>
    <img class="arrow-icon" src="@/assets/images/icon_arrow.png" />
    <div class="v-divider" />
  </div>
</template>

<script>
  export default {
    name: 'prefix-code-picker',

    props: {
      code: {
        type: String,
        default: '+86'
      }
    }
  }
</script>

<style lang="scss" scoped>
.prefix-code-picker {
  display: flex;
  justify-content: start;
  align-items: center;

  .code-text {
    font-size: 16px;
    color: #121212;
    font-weight: 400;
  }

  .arrow-icon {
    width: 8px;
    height: 5px;
    margin: 0 12px;
  }

  .v-divider {
    background: #f5f5f5;
    width: 1px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>
